/**
 * Tenant code from ?co=<code> (e.g. ?co=sd). Persisted for OAuth redirects that drop query params.
 */
export const TENANT_QUERY_PARAM = "co";

export function resolveTenantCode() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get(TENANT_QUERY_PARAM);
    if (fromUrl) {
      const normalized = fromUrl.trim().toLowerCase();
      sessionStorage.setItem(TENANT_QUERY_PARAM, normalized);
      return normalized;
    }
  } catch (_) {
    /* ignore */
  }

  try {
    return (sessionStorage.getItem(TENANT_QUERY_PARAM) || "").trim().toLowerCase();
  } catch (_) {
    return "";
  }
}

export function getTenantExtraQueryParameters() {
  const co = resolveTenantCode();
  return co ? { [TENANT_QUERY_PARAM]: co } : {};
}
